import { render } from "./PaymentSlipCharts.vue?vue&type=template&id=5df1a1ae"
import script from "./PaymentSlipCharts.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipCharts.vue?vue&type=script&lang=ts"
script.render = render

export default script